<template>
  <div class="flex">
    <div class="lp-date-picker">
      <vue-timepicker :minuteInterval="5" :value="time" @change="selTime" format="HH:mm"></vue-timepicker>
      <i class="material-icons icon-alarm" v-if="time.HH === ''">alarm</i>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object
      },
      type: {
        type: String
      },
      placeholder: {
        type: String,
        default: '시간 선택'
      }
    },
    data(){
      return {
        time: {
          HH: '',
          mm: ''
        },
        vInput: false
      }
    },
    created() {
      if ( this.data ) {
        if(this.data.HH !== undefined) {
          this.time = this.data;
        }
        else if(this.data.indexOf(':')>-1){
          let start_time = this.data.split(':')[0];
          let end_time = this.data.split(':')[1];
          this.time = {
            HH: start_time,
            mm: end_time
          };
        }
        else {
          this.$emit('setTime', { HH: '', mm: '' });
        }
      }
    },
    watch:{
      data(n){
        if(n){
          //console.log(n)
          if(n.search(':')>-1){
            let start_time = n.split(':')[0];
            let end_time = n.split(':')[1];
            this.time = {
              HH: start_time,
              mm: end_time
            };
          }
          else {
            this.time = {
              HH: '',
              mm: ''
            };
          }
        }
      }
    },
    methods: {
      selTime(time){
        this.time = time.data;
        if(time.data.HH && time.data.mm){
          this.$emit('setTime', time.data.HH + ':' + time.data.mm);
        }
      }
    }
  }
</script>

<style lang="scss">
  /*input {
    border: 1px solid #dbdbdb;
    color: #363636;
    padding: 8px;
    font-size: 1rem;
    border-radius: 3px;
    width: 80px;
    background-color: white;
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  }*/
  .lp-date-picker {
    position: relative;
  }

  .lp-dating {
    display:inline-block;
    margin: 0 8px;
    font-size: 18px;
    color:#064160;
  }

  .lp-date-picker ul {
    list-style: unset;
    margin-left: 0 !important;
    margin-top: 0 !important;
  }

  .time-picker input.display-time {
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    border-radius: 4px;
    border: 1px solid #ccc;
    padding-left: 10px !important;
    background: white;
    color: #555;
  }

  .icon-alarm {
    position: absolute;
    top: 5px;
    right: 4px;
    color: #989898;
    font-size: 22px;
  }
</style>
